const Colors = {
    backgroundDark: '#121212',
    backgroundLight: '#ffffff',
    primary: '#4b3c7c',
    navbarItems:'#d8d8e3',
    danger: '#e74c3c',
    warning: '#f1c40f',
    success: '#2ecc71',
    info: '#3498db',
    light: '#ecf0f1',
    dark: '#2c3e50',
    white: '#ffffff',
    greyLight:'#939598',
    desc:'#7d7e80',
    black: '#000000',
    link: '#0026ff',
    grey: '#95a5a6',
  };
  
  export default Colors;
  